module.exports = __webpack_public_path__ + "static/media/2.91cfff3d.png";